<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>


<script>
	export default {
		name: 'app',
		created() {},
		destroyed() {

		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	/*每个页面公共css */
	@import "./assets/css/szui.scss";
</style>
